// REACT
import React, { useEffect, RefObject, CSSProperties, useRef } from 'react'

// ESTILOS
import Style from './Carousel.module.css'

// PROPIEDADES
interface CarouselProps {
	imgs: string[]
	update?: boolean
	class1?: CSSProperties
	class2?: CSSProperties
	time?: number
}

const Carousel: React.FC<CarouselProps> = (props: CarouselProps) => {
	// REFERENCIAS
	const car: RefObject<HTMLDivElement> = useRef(null)

	useEffect(() => {
		// DEFINE IMAGEN PRINCIPAL
		if (car.current) car.current.style.backgroundImage = `url(${props.imgs[props.imgs.length - 1]})`

		// QUITAR BLUR
		if (props.update)
			setTimeout(() => {
				if (car.current) car.current.style.filter = 'blur(0)'
			}, 1000)

		// SLIDE
		let count: number = 0

		// INTERVALO
		const intervalo = setInterval(() => {
			if (car.current) {
				// CAMBIAR RUTA
				car.current.style.backgroundImage = `url(${props.imgs[count]})`

				// CAMBIAR CONTADOR
				count = count >= props.imgs.length - 1 ? 0 : count + 1
			}
		}, props.time || 5000)

		// LIMPIAR INTERVALO
		return () => clearInterval(intervalo)
	}, [props.imgs, props.update, props.time])

	return (
		<div className={`${Style.container} `} style={props.class1}>
			<div
				className={`${Style.img} `}
				ref={car}
				style={{
					backgroundImage: `ur(${props.imgs[props.imgs.length - 1]})`,
					width: `${props.class2 ? props.class2.width : '100%'}`,
					height: `${props.class2 ? props.class2.height : '100%'}`,
					borderRadius: `${props.class2 ? props.class2.borderRadius : '0px'}`,
				}}
			/>
		</div>
	)
}

export default Carousel
